import { IAction } from '../utils';
import { reducerTypes } from './types';
import { IAuth } from '../../interfaces/auth';

export const INITIAL: IAuth = {
  expiresIn: 0,
  token: '',
  refreshToken: '',
  loading: false,
};

export const authReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.LOADING:
      return { ...INITIAL, loading: true };
    case reducerTypes.LOGIN:
      return { ...payload, loading: false };
    case reducerTypes.LOGOUT:
      return INITIAL;
    default:
      return state;
  }
};
